import { Button, Col, Input, Row, Form, notification, Result } from "antd";
import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { PASSWORD_RULES } from "../../config/constant";
import { resetPasswordApi } from "../../config/Api";
import { apiErrorMessage } from "../../services/ApiError";
import "./style/ForgetPassword.scss";

// opened from the password reset email: /reset-password?token=...&email=...
export const ResetPassword = () => {
    const [form] = Form.useForm()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const token = searchParams.get('token') || ''
    const email = searchParams.get('email') || ''
    const [loading, setLoading] = useState(false)

    const onFinish = (values) => {
        setLoading(true)
        resetPasswordApi({ email, token, password: values.password })
            .then((res) => {
                notification.success({ message: res.data.message })
                navigate('/')
            })
            .catch((err) => {
                notification.error({ message: apiErrorMessage(err) })
            })
            .finally(() => setLoading(false))
    }

    return (
        <div className="ForgetPassword">
            <Form
                form={form}
                name="resetPasswordForm"
                className="ForgetPasswordForm"
                onFinish={onFinish}
            >
                <div className="logoSection">
                    <h2 className="mb-0">Nutri Nexus</h2>
                </div>
                <Row justify="center">
                    <Col xs={24} md={16} xl={11} xxl={{ span: 7 }} className="rightForm">
                        <div id="ForgotPasswordFormContent" className="p-4 rounded">
                            {!token || !email ? (
                                <Result
                                    status="warning"
                                    title="Invalid reset link"
                                    subTitle="Please open the link from the email again, or request a new one."
                                    extra={<Link to="/forget-password">Request a new link</Link>}
                                />
                            ) : (
                                <>
                                    <h4 className="text-center login-title">Choose a new password</h4>
                                    <p className="text-center text-muted">{email}</p>

                                    <label className="form-input-label">New Password:</label>
                                    <Form.Item
                                        name="password"
                                        validateFirst
                                        rules={[
                                            { required: true, message: "Please insert password!" },
                                            ...PASSWORD_RULES,
                                        ]}
                                    >
                                        <Input.Password placeholder="Enter new password" className="mt-2 p-2" />
                                    </Form.Item>

                                    <label className="form-input-label">Confirm Password:</label>
                                    <Form.Item
                                        name="confirm_password"
                                        dependencies={['password']}
                                        rules={[
                                            { required: true, message: "Please confirm password!" },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue('password') === value) {
                                                        return Promise.resolve()
                                                    }
                                                    return Promise.reject(new Error("Passwords do not match!"))
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input.Password placeholder="Re-enter new password" className="mt-2 p-2" />
                                    </Form.Item>

                                    <Button htmlType="submit" block loading={loading} className="submit-button border-0 rounded">
                                        Change Password
                                    </Button>
                                    <div className="text-center mt-3">
                                        <Link to="/">Back to login</Link>
                                    </div>
                                </>
                            )}
                        </div>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}
